import React from 'react';
import { useTranslation } from 'react-i18next';

import { Partnership } from 'components/common';

import imgManagementBackground from 'images/img-management.png';
import iconPersonalized from 'images/icon-personalized.svg';
import iconHeartPhone from 'images/icon-heart-phone.svg';
import iconDesktop from 'images/icon-desktop.svg';

interface LandingPageSection5Props {
  client?: string;
  customization?: ClientCustomization;
}

export default function LandingPageSection5({
  client,
  customization,
}: LandingPageSection5Props) {
  const { t } = useTranslation();

  const customizedIcons = customization?.managementIcons || [];
  const customizedTextKeys = customization?.managementTextKeys || [];
  const customizedTitleKeys = customization?.managementTitleKeys || [];

  const managements = [
    {
      title: 'section_5_management_title_1',
      text: 'section_5_management_desc_1',
      icon: iconPersonalized,
    },
    {
      title: 'section_5_management_title_2',
      text: 'section_5_management_desc_2',
      icon: iconHeartPhone,
    },
    {
      title: 'section_5_management_title_3',
      text: 'section_5_management_desc_3',
      icon: iconDesktop,
    },
  ];

  return (
    <div id="recommendations">
      <img
        src={
          customization?.section5Background?.mobileDE || imgManagementBackground
        }
        alt="Ninebarc Features"
        className="t-w-full t-mt-20 lg:t-hidden"
      />
      <div className="t-relative xl:t-mt-32 xl:t-pb-32 t-flex t-justify-center t-overflow-hidden">
        <div className="t-absolute t-top-0 -t-right-9 t-max-w-sm t-hidden lg:t-inline-block">
          <img
            src={
              customization?.section5Background?.desktopDE ||
              imgManagementBackground
            }
            alt="Ninebarc Features"
            className="t-w-96 xl:t-w-auto"
          />
        </div>

        <div className="t-max-w-xl t-w-full t-mt-10 t-flex t-justify-center lg:t-justify-start xxl2:t-flex xxl2:t-justify-center">
          <div>
            {customization?.section5LogoHeader && (
              <div className="t-mb-9">
                <Partnership customization={customization} />
              </div>
            )}
            <div className="t-flex t-justify-center lg:t-justify-start">
              <p
                className={`t-rounded t-px-6 t-py-3 t-bg-delta-200 t-text-delta-700 t-font-semibold ${client}_section_badge`}
              >
                {t('section_5_header')}
              </p>
            </div>

            <div className="t-mx-3 lg:t-p-0" style={{ maxWidth: '640px' }}>
              <p
                className={`Text-header-sub t-mt-4 t-text-center lg:t-text-start ${client}_section_header`}
              >
                {t('section_5_title')}
              </p>
              {managements.map(({ title, text, icon }, idx) => (
                <div
                  key={title}
                  className="t-flex t-flex-col lg:t-flex-row t-items-center t-mt-9"
                >
                  <div
                    className="t-rounded t-shadow-md t-flex t-justify-center t-items-center lg:t-mr-10"
                    style={{ width: '72px', height: '72px' }}
                  >
                    <img src={customizedIcons[idx] || icon} alt={text} />
                  </div>

                  <div className="t-max-w-112 t-mt-3 lg:t-mt-0 lg:t-pr-10 t-text-center lg:t-text-start">
                    <p className={`Text-normal ${client}_text_title`}>
                      {t(customizedTitleKeys[idx] || title)}
                    </p>
                    <p
                      className={`Text-normal t-font-normal t-mt-1 ${client}_text_desc`}
                    >
                      {t(customizedTextKeys[idx] || text)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
